import React, {Component} from 'react';
import './CustomerSalesItemTableHeader.css';
import {FormattedMessage} from "react-intl";


class CustomerItemTableHeader extends Component {

    render() {
        return (
            <div>
                <div className="row view-details-table-header">
                    <div className="col-md-2 custom-col-2">
                        <label className="admin-view-single-order-label">商品番号</label>
                    </div>
                    <div className="col-md-2 custom-col-2">
                        <label>
                            <FormattedMessage id="app.admin.view.single.order.file"
                                              defaultMessage="Item File"
                                              description=""/>
                        </label>

                    </div>
                    <div className="col-md-2 custom-col-2">
                        <label className="admin-view-single-order-label">
                            {/*<FormattedMessage id="app.admin.view.single.order.item"
                                              defaultMessage="Item"
                                              description=""/>*/}
                            佐川番号
                        </label>
                    </div>
                    <div className="col-md-1 custom-col-1">
                        <label className="admin-view-single-order-label">
                            <FormattedMessage id="app.admin.view.single.order.qty"
                                              defaultMessage="Qty"
                                              description=""/>
                        </label>
                    </div>
                    <div className="col-md-2 custom-col-2">
                        <label className="admin-view-single-order-label order-view-table-cost">
                            {/*<FormattedMessage id="app.admin.view.single.order.total"
                                              defaultMessage="Item Cost"
                                              description=""/>*/}
                            小計(¥)
                        </label>
                    </div>
                    <div className="col-md-1 custom-col-1 no-margin">
                        <label className="admin-view-single-order-label order-view-table-cost">
                           {/* <FormattedMessage id="app.admin.view.single.order.order-type"
                                              defaultMessage="Order type"
                                              description=""/>*/}
                            タイプ
                        </label>
                    </div>
                    <div className="col-md-2 custom-col-2">
                        <label className="admin-view-single-order-label">
                            <FormattedMessage id="app.admin.view.single.order.action"
                                              defaultMessage="Action"
                                              description=""/>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <hr className="admin-single-order-header-hr"/>
                </div>
            </div>
        )
    }
}
export default CustomerItemTableHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CustomerSalesItemTableHeader/CustomerSalesItemTableHeader.js